module.exports = __webpack_public_path__ + "img/pizza_chorizo.196d0453.jpg";